import React from 'react';

export const LeaderCardContext = React.createContext();
LeaderCardContext.displayName = "LeaderCardContext";

export function useLeaderCard() {
  const context = React.useContext(LeaderCardContext);

  if (context === undefined) {
    throw new Error("useLeaderCard must be used in a <LeaderCardContext/>");
  }

  return context;
}

const getSortedData = ({ data, orderBy }) => {

  if (!data?.team_statistics) {
    return data;
  }

  const orderedData = [...data?.team_statistics];

  orderedData.sort((a, b) => b[orderBy] - a[orderBy]);
  return { ...data, team_statistics: orderedData.slice(0, 4) };
};

export default getSortedData;
